import { SVTabs } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import TransactionReviewList from '@/components/transactionReview/TransactionReviewList';
import { Card, Typography } from '@mui/material';

export default function TransactionReviewPage() {
  return (
    <DefaultLayout header="Transaction Review">
      <Card>
        <Typography variant="h5" mb={2}>
          Request Status
        </Typography>
        <SVTabs
          headers={['Under Review', 'Approved', 'Declined', 'Canceled']}
          panels={[
            <TransactionReviewList
              key="under-review-list"
              status="under review"
            />,
            <TransactionReviewList key="approved-list" status="approved" />,
            <TransactionReviewList key="declined-list" status="declined" />,
            <TransactionReviewList key="canceled-list" status="canceled" />,
          ]}
        />
      </Card>
    </DefaultLayout>
  );
}
